import React from 'react';
import { Card, CardProps, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Fancy Card with hover effects and animations
const FancyCardStyled = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
    transition: 'left 0.5s',
  },
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)',
  },
  '&:hover::before': {
    left: '100%',
  },
}));

interface FancyCardProps extends CardProps {
  children: React.ReactNode;
  glowColor?: string;
}

export const FancyCard: React.FC<FancyCardProps> = ({ 
  children, 
  glowColor = '#006D75',
  sx,
  ...props 
}) => {
  return (
    <FancyCardStyled
      {...props}
      sx={{
        ...sx,
        '&:hover': {
          ...(sx as any)?.hover,
          boxShadow: `0 12px 24px ${glowColor}40`,
        },
      }}
    >
      {children}
    </FancyCardStyled>
  );
};

export default FancyCard;









